(function($) {
    plae = window.plae || {};
    plae.callbacks = {
        callbacks: {},
        run: function(type, args) {
            if (this.callbacks[type]) {
                for (var i = 0; i < this.callbacks[type].length; i++) {
                    this.callbacks[type][i].apply(this, args);
                }
            }
        },
        add: function(fun, type) {
            if (!this.callbacks[type]) this.callbacks[type] = [];
            if(fun && type) this.callbacks[type].push(fun);
        }
    };

    // set base media path
    var imagekitenabled = false;
    
    plae.mediapath = (imagekitenabled) ? 'https://m.plae.co/' : '//cdn.shopify.com/s/files/1/0406/7793/3205/files/';

    jQuery(window).on("load", function() {
        if (window.plae && plae.callbacks) plae.callbacks.run("pageload");
    });
})(jQuery);

/* Klaviyo Back in Stock (added 2026-07-31).
   Kept in its own asset so this bootstrap file stays focused.
   To disable the feature entirely, delete this block. */
(function () {
    var s = document.createElement('script');
    s.src = '//plae.co/cdn/shop/t/56/assets/klaviyo-bis.js?v=28734596829379040541786491559';
    s.defer = true;
    document.head.appendChild(s);
})();

/* Product info column height fix (added 2026-08-11).
   On product pages with a short image gallery (e.g. a single photo), the
   sticky info column (.Product__Info) can end up taller than the gallery
   that determines the section's height, because .Product__InfoWrapper is
   position:absolute and doesn't contribute to the section's flow height.
   When that happens, the section's box ends before the info column's
   content actually does, so the next section on the page (Rebuy's
   "Frequently Bought Together" / "You may also like" widgets) renders on
   top of the tail end of the info column instead of below it.
   This keeps the section at least as tall as its info column, re-checking
   after async widgets (Rebuy, Judge.me) inject additional content.
   To disable, delete this block. */
(function () {
    function initProductInfoHeightFix() {
        var section = document.querySelector('.template-product .Product__Wrapper');
        var info = section && section.querySelector('.Product__Info');
        if (!section || !info) return;

        var naturalHeight = null;

        function sync() {
            if (naturalHeight === null) {
                section.style.minHeight = '';
                naturalHeight = section.getBoundingClientRect().height;
            }
            var target = Math.max(naturalHeight, info.scrollHeight);
            section.style.minHeight = target + 'px';
        }

        sync();
        window.addEventListener('load', sync);
        setTimeout(sync, 1200);
        setTimeout(sync, 3000);

        if (window.ResizeObserver) {
            new ResizeObserver(sync).observe(info);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProductInfoHeightFix);
    } else {
        initProductInfoHeightFix();
    }
})();
